import { CART_MODULE } from "@/api_framework/api_config";
import axios from "axios";
import { useCallback } from "react";
import { useConfiguration } from "../../useConfiguration";

export interface IMirrorStatePayload {
  screen: string;
  status: string;
  cart_id?: string | null;
  customer_id?: string | null;
  [key: string]: unknown;
}

export const useUpdateMirrorStateAPI = () => {
  const configuration = useConfiguration();

  const execute = useCallback(
    async (payload: IMirrorStatePayload) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const endpoint = CART_MODULE?.MIRROR_STATE?.baseURL ?? "";

        await axios.post(endpoint, payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
      } catch (e: any) {
        console.error("[MirrorState] failed to update:", payload, e);
      }
    },
    [configuration],
  );

  return { execute };
};
